/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Lede1Inputs */

const en_guides_lede1 = /** @type {(inputs: Guides_Lede1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six guides, written against the tools on this site.
When a guide states what a parser does with a trailing comma or how much gzip saves on a minified payload, that number came from running it, not from another article.`)
};

const ko_guides_lede1 = /** @type {(inputs: Guides_Lede1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 사이트의 도구를 기준으로 쓴 여섯 편입니다.
파서가 뒤따르는 쉼표를 어떻게 처리하는지, 압축한 payload에서 gzip이 얼마나 줄여주는지 같은 서술은 다른 글에서 옮긴 것이 아니라 직접 실행해서 확인한 값입니다.`)
};

const ja_guides_lede1 = /** @type {(inputs: Guides_Lede1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサイトのツールを基準に書いた6編です。
パーサーが末尾のカンマをどう扱うか、圧縮したペイロードでgzipがどれだけ削減するかといった記述は、他の記事から引いたものではなく、実際に実行して確認した値です。`)
};

/**
* | output |
* | --- |
* | "Six guides, written against the tools on this site. When a guide states what a parser does with a trailing comma or how much gzip saves on a minified payload..." |
*
* @param {Guides_Lede1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_lede1 = /** @type {((inputs?: Guides_Lede1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Lede1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_lede1(inputs)
	if (locale === "ko") return ko_guides_lede1(inputs)
	return ja_guides_lede1(inputs)
});